import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { CassandraLinkedService } from 'app/model/linkedservice/cassandra.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { CONNECTOR_VERSION20 } from 'app/services/globals';
import { driverVersions } from 'app/registries/consts/tabular-consts';


@AdapterRegistry.adapter({
    model: Metamodel.modelFor(CassandraLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            version: '*',
            typeProperties: {
                host: '*',
                authenticationType: '*',
                port: '*',
                username: '*',
                password: 'secret',
                encryptedCredential: '*'
            }
        },
    }
})
export class CassandraLinkedServiceAdapter extends LinkedServiceAdapter<CassandraLinkedService> {
    protected modelConstructor(): new () => CassandraLinkedService {
        return CassandraLinkedService;
    }

    protected model(): IModel {
        return CassandraLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: CassandraLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.CassandraLinkedService;
        properties.type = Metamodel.modelFor(CassandraLinkedService).name;
        if (linkedService.version === driverVersions.v2) {
            properties.version = CONNECTOR_VERSION20;
        }
        properties.typeProperties = {
            host: linkedService.host,
            port: linkedService.port,
            authenticationType: linkedService.authenticationType,
            username: linkedService.authenticationType === 'Basic' ? linkedService.userName : undefined,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            password: (linkedService.authenticationType === 'Basic') ? passwordOrAKVtoSecretBase(linkedService.password, this.context) : undefined
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: CassandraLinkedService): Promise<CassandraLinkedService> {
        const properties = linkedServiceResource.properties as Model.CassandraLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.CassandraLinkedServiceTypeProperties = properties.typeProperties;
        linkedService.version = properties.version === CONNECTOR_VERSION20 ? driverVersions.v2 : driverVersions.v1;
        if (__IS_FABRIC_DPE__) { // currently Cassandra is not supported in fabric DPE but to avoid warning in fabric in future
            linkedService.version = driverVersions.v2;
        }
        linkedService.isLegacyConnector = linkedService.version === driverVersions.v1;
        linkedService.host = typeProperties.host;
        linkedService.port = typeProperties.port;
        linkedService.authenticationType = typeProperties.authenticationType;
        linkedService.userName = typeProperties.username;
        linkedService.password = secretBaseToPasswordOrAKV(typeProperties.password, typeProperties.authenticationType === 'Basic', this.context);
        return linkedService;
    }
}
